import { Graph } from "@maxgraph/core";
import { CustomCell } from "../models/diagram.models";
import { CellHoverTarget, PopoverAnchorData } from "./popover.models";
import { Injectable } from "@angular/core";
import { DiagramCardData } from "@nms-angular-toolkit/nms-diagram-card";

/**
 * Responsável por criar o objeto com os dados de controle para montar um popover do diagrama.
 */
@Injectable({providedIn: "root"})
export class PopoverDataService {

    constructor() {
        // Construtor intencionalmente vazio
    }

    /**
     * Cria o objeto contendo os dados necessários para criação do popover.
     *
     * @param graph - Gráfico.
     * @param cell - Célula a qual o popover pertence.
     * @param data - Dados a serem enviados para o popover.
     *
     * @returns Objeto contendo os dados necessários para criação do popover (@see CellHoverTarget).
     */
    create(graph: Graph, cell: CustomCell, data: DiagramCardData): CellHoverTarget {
        const getTopRightAnchorRect = (target) => {
            let { x, y, state } = this.getPopoverAnchorData(graph, target);

            x += state.width; // Adiciona largura da célula para obter o canto superior direito

            return new DOMRect(x, y, 0, 0);
        }

       return {
            id: cell.id,
            isFixed: false,
            cell,
            data,
            getAnchorRect: getTopRightAnchorRect
        };
    }

    /**
     * Retorna um objeto com os dados necessários para calcular o posicionamento do popover.
     *
     * Aqui X e Y indican o canto superior esquerdo da célula que recebeu o hover.
     *
     * @param graph - Gráfico.
     * @param target - Célula a qual o popover pertence.
     *
     * @returns dados necessários para calcular a posição do popover.
     */
    private getPopoverAnchorData(graph: Graph, target: CellHoverTarget): PopoverAnchorData {
        const state = graph.view.getState(target.cell);
        const graphRect = graph.container.getBoundingClientRect();
        const scrollLeft = graph.container.scrollLeft;
        const scrollTop = graph.container.scrollTop;

        const x = graphRect.left + state.x - scrollLeft;
        const y = graphRect.top + state.y - scrollTop;

        return { x, y, state, graphRect };
    }
}
